<template>
    <div class="register" >
      <div class="register-top">
          <div class="lg-rg">
              <img src="@/assets/img/client/login/609/20230609-1.jpg"  alt=""/>
              <div class="lg-tb lg-tb-search">
                    <img src="@/assets/img/client/login/609/consult.png" @click="handlerConsult" alt=""/>
                  <!-- <img src="@/assets/img/client/login/consult.png" @click="handlerConsult" alt=""/> -->
              </div>
              <div class="lg-tb-search">
                
              </div>
          </div>

          <div class="lg-rg">
              <img src="@/assets/img/client/login/609/20230609-2.jpg"  alt=""/>
              <div class="lg-tb">
                    <a href="#register">
                      <img src="@/assets/img/client/login/logo-register.png"  alt=""/>
                  </a>
              </div>
              <div class="lg-tb-search">
                
              </div>
          </div>
          
          <div class="lg-rg-2">
              <img src="@/assets/img/client/login/2022-10-27-2.jpg" alt="">
              <div class="lg-more">
                  <img src="@/assets/img/client/login/more.png" alt="" @click="handleClick">
              </div>
          </div>
          <!-- <img src="@/assets/img/client/login/2022-10-27-3.jpg" alt=""> -->
      </div>
      <!-- <div class="login-logo">
        <img src="@/assets/img/client/login/logo.png" />
      </div> -->
          <div class="register-bg" :style="{'height': documentClientHeight + 'px'}">
              <div class="register-content">
                  <!-- <div class="site-name"></div> -->
                  <!-- <div class="title"></div> -->
                  <div class="form-content">
                      <!-- <div class="register-mode" @click="phoneLogin = !phoneLogin">
              <div v-if="!phoneLogin" class="qrcode"></div>
              <div v-else class="basic"></div>
            </div> -->
                      <div class="form-box">
                          <!-- <h1>一咻通关</h1> -->
                          <!-- <el-row v-show="isWxCodeLogin && !phoneLogin">
                <div class="registration">快速注册</div>
              </el-row> -->
                          <el-row style="position: relative;" v-show="!isWxCodeLogin">
                              <div class="active-bar" :style="{
                    color: !phoneLogin ? '#0068b7' : '#fff',
                    width: !phoneLogin ? '100px' : '100px',
                    transform: !phoneLogin
                      ? 'translateX(42px)'
                      : 'translateX(229px)'
                  }"></div>
                              <el-col :span="12">
                                  <div :class="{ active: !phoneLogin, inner: phoneLogin }" @click="checkoutIswxLogin">
                                      账号密码登录
                                  </div>
                              </el-col>
                              <el-col :span="12">
                                  <div :class="{ active: phoneLogin, inner: !phoneLogin }" @click="()=>{
                      isWxCodeLogin = false;
                      phoneLogin = true;
                    }
                  ">
                                      快捷注册登录
                                  </div>
                              </el-col>
                          </el-row>
                          <a name="register"></a>
                          <el-form :model="regForm" :rules="regRule" ref="register" @keyup.enter.native="regSubmit"
                              status-icon v-show="phoneLogin && !isWxCodeLogin">
                              <div class="user-client-reg">
                                  <el-form-item class="user" prop="username">
                                      <el-input v-model="regForm.username" type="number" autocomplete="off"
                                          placeholder="请输入手机号码">
                                          <i slot="prefix" class="el-icon-mobile-phone"></i>
                                      </el-input>
                                  </el-form-item>
                                  <el-form-item prop="captcha" class="phone-code">
                                      <div class="ph-code-number">
                                          <el-input v-model="regForm.captcha" autocomplete="off" clearable type="number"
                                              placeholder="请输入手机验证码"></el-input>
                                      </div>
                                      <div class="ph-code-btn" style="font-size: 0;">
                                          <el-button size="small" :disabled="isCodeDisabled || !isCode" autocomplete="off"
                                              @click="checkedPhoneCode">{{ phoneCodeBtn }}</el-button>
                                      </div>
                                  </el-form-item>
                              </div>
                              <!-- <u
                  style="float: right;cursor: pointer;margin-top: -2px"
                  @click="coderegister"
                  >微信扫码登录</u
                > -->
                              <el-button class="register-btn-submit" style="margin-top: 40px;margin-bottom: 15px"
                                  :loading="fullscreenLoading" type="primary" @click="regSubmit" size="medium">注册/登录
                              </el-button>
                              <u style="width: 100%;cursor: pointer" @click="codeLogin">微信扫码登录</u>
                          </el-form>
                          <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit"
                              status-icon v-show="!phoneLogin && !isWxCodeLogin">
                              <div class="user-client-register">
                                  <el-form-item class="user" prop="userName">
                                      <el-input v-model="dataForm.userName" placeholder="请输入登录账号">
                                         
                                      </el-input>
                                  </el-form-item>
                                  <el-form-item class="pwd" prop="password">
                                     
                                        <el-input v-model="dataForm.password" type="password" placeholder="请输入登录密码">
                                            
                                        </el-input>
                                      <!-- <div class="forgot-password">
                      <p class="button">忘记密码？</p>
                    </div> -->
                                  </el-form-item>
                              </div>
                              <el-form-item class="checked">
                                  <el-checkbox v-model="checked">记住我</el-checkbox>
                              </el-form-item>
                              <el-button class="register-btn-submit"
                                  style="margin-bottom: 15px;margin-top:-12px;over-flow: hidden"
                                  :loading="fullscreenLoading" type="primary" @click="dataFormSubmit" size="medium">登录
                              </el-button>
  
                              <u style="width: 100%;cursor: pointer" @click="codeLogin">微信扫码登录</u>
                          </el-form>
                          <div v-show="isWxCodeLogin" class="codeLogin">
                              <div class="register-qrcode" id="loginQrcode"></div>
                              <u style="width: 100%;cursor: pointer;position: absolute; bottom: 20px; right: 0px;" @click="()=>{
                                isWxCodeLogin = false;
                                phoneLogin = true;
                                }
                            ">返回账号密码登录</u>
                          </div>
                      </div>
                  </div>
              </div>
  
              <!-- <div class="login-foot-img">
                  <div class="img" @click="handlerGohome">
                      <img src="@/assets/img/client/login/go-home.png" height="100" />
                  </div>
              </div> -->
          </div>
  
  
          <el-dialog title="请选择租户" :visible.sync="dialog" width="30%">
              <div class="radio-box">
                  <el-radio-group v-model="tenantId">
                      <el-radio v-for="(item, i) in tenants" :key="i" :label="i">{{
              item.tenantName
            }}</el-radio>
                  </el-radio-group>
              </div>
              <span slot="footer" class="dialog-footer">
                  <el-button @click="dialog = false">取 消</el-button>
                  <el-button type="primary" :loading="setTenantState" @click="setTenant">确 定</el-button>
              </span>
          </el-dialog>
  
          <el-dialog width="30%" append-to-body title="重置密码" :show-close="false" :visible.sync="password.show"
              :close-on-click-modal="false" :close-on-press-escape="false" class="resetPassword">
              <el-form :model="password.data" status-icon :rules="password.rules" ref="passwordForm" label-width="100px">
                  <el-form-item label="密码：" prop="pass">
                      <el-input type="password" v-model="password.data.pass" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="确认密码：" prop="checkPass">
                      <el-input type="password" v-model="password.data.checkPass" autocomplete="off"></el-input>
                  </el-form-item>
              </el-form>
              <span slot="footer" class="dialog-footer">
                  <el-button @click="closePassword">取 消</el-button>
                  <el-button type="primary" :loading="password.loading" @click="resetPassword">确 定</el-button>
              </span>
          </el-dialog>
  
          <el-dialog title="绑定账号" :visible.sync="bindDialog" :before-close="bindDialogClose" :close-on-click-modal="false"
              :close-on-press-escape="false" width="30%">
              <div>
                  <p style="margin-bottom:15px;text-align:center;">
                      首次扫码登录，请绑定您的阿贝尔账号
                  </p>
                  <el-form :model="bindForm" :rules="dataRule" ref="bindForm" class="bindForm" size="small"
                      label-width="60px" @keyup.enter.native="bindFormSubmit" status-icon>
                      <el-form-item label="账号：" prop="userName" :rules="dataRule.userName">
                          <el-input v-model="bindForm.userName" clearable></el-input>
                      </el-form-item>
                      <el-form-item label="密码：" prop="password" :rules="dataRule.password">
                          <el-input v-model="bindForm.password" type="password" clearable></el-input>
                      </el-form-item>
                  </el-form>
              </div>
              <span slot="footer" class="dialog-footer">
                  <el-button @click="bindDialogClose">取 消</el-button>
                  <el-button type="primary" :loading="bindLoading" @click="bindFormSubmit">绑定</el-button>
              </span>
          </el-dialog>
          <el-dialog
              v-model="dialogVisible"
              custom-class="register-dialog"
              title="扫码咨询客服"
              width="405px"
              :show-close="false"
              :before-close="handleClose">
              <img src="@/assets/img/client/login/qrcode.jpg" alt="">
              </el-dialog>
      </div>
  </template>
  <script>
      import {
          mapActions
      } from "vuex";
      import vueCookie from 'vue-cookies'
      export default {
          data() {
              const validatePass = (rule, value, callback) => {
                  if (!value) {
                      return callback(new Error("请输入密码"));
                  } else {
                      if (value.length < 6 || value.length > 16) {
                          return callback(new Error("密码长度为6~16位字符"));
                      }
  
                      if (/(\w)\1\1/g.test(value)) {
                          return callback(new Error("密码设置过弱，请重新设置"));
                      }
  
                      let reg = new RegExp("(?=.*[0-9])(?=.*[a-zA-Z])");
                      if (!reg.test(value)) {
                          return callback(new Error("密码必须含有数字+字母"));
                      }
  
                    //   const LxStr = str => {
                    //       const arr = str.split("");
                    //       let flag = false;
                    //       for (let i = 1; i < arr.length - 1; i++) {
                    //           const firstIndex = arr[i - 1].charCodeAt();
                    //           const secondIndex = arr[i].charCodeAt();
                    //           const thirdIndex = arr[i + 1].charCodeAt();
                    //           if (
                    //               thirdIndex - secondIndex === 1 &&
                    //               secondIndex - firstIndex === 1
                    //           ) {
                    //               flag = true;
                    //           }
                    //       }
                    //       return flag;
                    //   };
  
                    //   if (LxStr(value)) {
                    //       return callback(new Error("密码不允许出现连续3位递增字符"));
                    //   }
  
                      if (this.password.data.checkPass !== "") {
                          this.$refs.passwordForm.validateField("checkPass");
                      }
                      callback();
                  }
              };
              const validatePass2 = (rule, value, callback) => {
                  if (!value) {
                      callback(new Error("请再次输入密码"));
                  } else if (value !== this.password.data.pass) {
                      callback(new Error("两次输入密码不一致!"));
                  } else {
                      callback();
                  }
              };
              const checkEmail = (rule, value, callback) => {
                  const mailReg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
                  if (!value) {
                      return callback(new Error("邮箱不能为空"));
                  }
                  setTimeout(() => {
                      if (mailReg.test(value)) {
                          callback();
                      } else {
                          callback(new Error("请输入正确的邮箱格式"));
                      }
                  }, 100);
              };
              return {
                  cnAddress: "", //登录地址
                  loginRemoteIp: "", //登录IP
                  mac: "", // mac地址
                  isWxCodeLogin: false,
                  setTenantState: false,
                  dialog: false,
                  password: {
                      show: false,
                      loading: false,
                      data: {},
                      rules: {
                          pass: [{
                              validator: validatePass,
                              trigger: "blur"
                          }],
                          checkPass: [{
                              validator: validatePass2,
                              trigger: "blur"
                          }]
                      }
                  },
                  tenant: "",
                  tenantId: "",
                  tenants: [],
                  redirect_uri: "",
                  phoneLogin: true,
                  bindDialog: false,
                  bindLoading: false,
                  bindForm: {
                      userName: "",
                      password: "",
                      openId: ""
                  },
                  dataForm: {
                      userName: "",
                      password: "",
                      captcha: ""
                  },
                  dataRule: {
                      userName: [{
                          required: true,
                          message: "帐号不能为空",
                          trigger: "blur"
                      }],
                      password: [{
                          required: true,
                          message: "密码不能为空",
                          trigger: "blur"
                      }],
                      captcha: [{
                          required: true,
                          message: "验证码不能为空",
                          trigger: "blur"
                      }],
                      enterpriseMail: []
                  },
                  regForm: {
                      enterpriseName: "",
                      username: "",
                      enterpriseMail: "",
                      captcha: ""
                  },
                  regRule: {
                      enterpriseName: [{
                          required: true,
                          message: "请输入企业名称",
                          trigger: "blur"
                      }],
                      username: [{
                              required: true,
                              message: "请输入手机号码",
                              trigger: "blur"
                          },
                          {
                              validator: (rule, value, callback) => {
                                  if (value) {
                                      if (value.length !== 11) {
                                          callback(new Error("手机号码错误"));
                                      }
                                  }
                                  callback();
                              },
                              trigger: "blur"
                          }
                      ],
                      enterpriseMail: [{
                          validator: checkEmail,
                          trigger: "blur"
                      }],
                      captcha: [{
                              required: true,
                              message: "请输入手机验证码",
                              trigger: "blur"
                          },
                          {
                              validator: (rule, value, callback) => {
                                  if (value) {
                                      if (value.length !== 5) {
                                          callback(new Error("验证码错误"));
                                      }
                                  }
                                  callback();
                              },
                              trigger: "blur"
                          }
                      ]
                  },
                  captchaPath: "",
                  checked: false,
                  fullscreenLoading: false,
                  phoneCodeBtn: "获取手机验证码",
                  isCodeDisabled: false,
                  routeQuery: {},
                  dialogVisible: false,
                  documentClientHeight: '600'
              };
          },
          computed: {
              isCode: {
                  get() {
                      return this.regForm.username && this.regForm.username.length === 11
                  }
              }
          },
          watch: {
              $route(to, from) {
                  if (to.query && to.query.code) {
                      this.wechatQRCodeLogin(to.query.code)
                  }
              }
          },
          created() {
              let query = this.$route.query || {}
              this.routeQuery = Object.keys(query).length ? query : this.routeQuery
              this.cnAddress = returnCitySN ? returnCitySN["cname"] : "" //登录地址
              this.loginRemoteIp = returnCitySN ? returnCitySN["cip"] : "" //登录IP
              this.mac = "" // mac地址
              console.log(this.cnAddress, this.loginRemoteIp)
              var isMobi = navigator.userAgent.toLowerCase().match(
                  /(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince|microMessenger)/i
                  ) != null
              if (isMobi) {
                  let paths = window.location.href
                  let parame = ''
                  if (paths.indexOf('?') != -1) {
                      parame = paths.substring(paths.indexOf('?'))
                  }
                  let url = ''
                  switch (process.env.VUE_APP_ENV) {
                      case 'prod':
                          url = 'https://h5.z-easy.com.cn/#/poster-discount'
                          break
                      case 'uat':
                          url = 'http://h5.uat.z-easy.com.cn/#/poster-discount'
                          break
                      case 'uat3':
                          url = 'http://h5.uat3.z-easy.com.cn/#/poster-discount'
                          break
                      case 'test':
                          url = 'http://h5.test.z-easy.com.cn/#/poster-discount'
                          break
                      case 'dev':
                          url = 'http://h5.dev.z-easy.com.cn/#/poster-discount'
                          break
                  }
                  window.location.href = url + parame
              }
          },
          mounted() {
              let body = document.getElementsByTagName('body')[0]
              body.style.overflow = 'auto'
              this.documentClientHeight = document.documentElement['clientHeight']
              // let qidian = document.getElementsByClassName('qidian_wpa_img')
              // if (qidian.length) {
              // 	qidian[0].style.display = 'none'
              // }
              // this.redirect_uri = encodeURIComponent('https://weixin.cicsc.com/dev/#/login')
              this.redirect_uri = encodeURIComponent(window.location.href)
              // this.redirect_uri = 'https://weixin.cicsc.com/dev/#/login'
              // 引入微信登录JS
              const wxScript = document.createElement("script")
              wxScript.type = "text/javascript"
              wxScript.src =
                  "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js"
              document.body.appendChild(wxScript)
              wxScript.onload = () => {
                  this.wechatLoginInit()
              };
              this.getAccount()
              
          },
          methods: {
              codeLogin() {
                  this.isWxCodeLogin = true
                  this.regForm = {
                      enterpriseName: "",
                      username: "",
                      enterpriseMail: "",
                      captcha: ""
                  };
                  this.regForm = {
                      enterpriseName: "",
                      username: "",
                      enterpriseMail: "",
                      captcha: ""
                  };
              },
              checkshowRegistered() {
                  this.isWxCodeLogin = !this.isWxCodeLogin;
                  if (this.isWxCodeLogin) {
                      this.regForm = {
                          enterpriseName: "",
                          username: "",
                          enterpriseMail: "",
                          captcha: ""
                      };
                      this.$nextTick().then(() => {
                          setTimeout(() => {
                              this.$refs.register.resetFields()
                          }, 500)
                      });
                  } else {
                      this.dataForm = {
                          userName: "",
                          password: "",
                          captcha: ""
                      };
                      this.$nextTick().then(() => {
                          setTimeout(() => {
                              this.$refs.dataForm.resetFields()
                          }, 500)
                      });
                  }
              },
              checkoutIswxLogin() {
                  this.phoneLogin = !this.phoneLogin;
                  if (this.phoneLogin) {
                      this.regForm = {
                          enterpriseName: "",
                          username: "",
                          enterpriseMail: "",
                          captcha: ""
                      };
                      this.$nextTick().then(() => {
                          setTimeout(() => {
                              this.$refs.register.resetFields()
                          }, 500)
                      });
                      // setTimeout(() => {
                      //   this.regForm = {}
                      //   this.$refs.register.resetFields()
  
                      // }, 500)
                  } else {
                      this.dataForm = {
                          userName: "",
                          password: "",
                          captcha: ""
                      };
                      this.$nextTick().then(() => {
                          // this.dataForm = {}
                          // this.$refs.dataForm.resetFields()
                          setTimeout(() => {
                              this.$refs.dataForm.resetFields()
                          }, 500)
                      });
                      // setTimeout(() => {
                      //   this.dataForm = {}
                      //   this.$refs.dataForm.resetFields()
  
                      // }, 500)
                  }
              },
              regSubmit() {
                  this.$refs.register.validate(valid => {
                      if (valid) {
                          this.fullscreenLoading = true
                          let params = this.regForm
                          params.cnAddress = this.cnAddress
                          params.loginRemoteIp = this.loginRemoteIp
                          params.loginMode = "sj"
                          params.clientSource = "2"
                          params.spreadChannelId = this.routeQuery.spreadChannelId
                          params.spreadUserId = this.routeQuery.spreadUserId
                          this.$post("/gateway/mobileCaptchaLogin", params)
                              .then(({
                                  data
                              }) => {
                                  if (data && data.code === "C0000") {
                                      this.authAfter(data)
                                  }
                              })
                              .finally(() => {
                                  this.fullscreenLoading = false
                              });
                      }
                  });
              },
              checkedPhoneCode() {
                  this.isCodeDisabled = true
                  let that = this
                  this.$get("/p/message/mobile/sendMobileCode", {
                          mobile: this.regForm.username
                      })
                      .then(({
                          data
                      }) => {
                          if (data && data.code === "C0000") {
                              let index = 60
                              let codeTime = setInterval(() => {
                                  if (index <= 0) {
                                      clearInterval(codeTime)
                                      that.isCodeDisabled = false
                                      that.phoneCodeBtn = "获取手机验证码"
                                  } else {
                                      this.phoneCodeBtn = "重新获取(" + index + ")"
                                      index--
                                  }
                              }, 1000);
                          } else {
                              this.isCodeDisabled = false
                          }
                      })
                      .catch(() => {})
              },
              wechatLoginInit() {
                  let ba64Css =
                      "LmltcG93ZXJCb3gge3dpZHRoOiAyMDBweDt9Ci5pbXBvd2VyQm94IC5xcmNvZGUge3dpZHRoOiAyMDBweDttYXJnaW46IDA7fQouaW1wb3dlckJveCAudGl0bGUge2Rpc3BsYXk6IG5vbmU7fQouaW1wb3dlckJveCAuaW5mbyB7d2lkdGg6IDIwMHB4O30KLmltcG93ZXJCb3ggLnN0YXR1cyB7cGFkZGluZzogMDt0ZXh0LWFsaWduOiBjZW50ZXI7fQouaW1wb3dlckJveCAuc3RhdHVzIC5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZTt9";
                  new WxLogin({
                      id: "loginQrcode",
                      appid: "wx8fb4cc515ed2c998",
                      scope: "snsapi_login",
                      redirect_uri: this.redirect_uri,
                      state: "",
                      style: "",
                      sandbox: "allow-scripts allow-top-navigation allow-same-origin",
                      href: "data:text/css;base64," + ba64Css
                  });
                  //   this.$router.push({ path: "/login" })
              },
              wechatQRCodeLogin(code) {
                  if (Array.isArray(code)) {
                      code = code.pop()
                  }
                  let data = {
                      code
                  }
                  data.cnAddress = this.cnAddress
                  data.loginRemoteIp = this.loginRemoteIp
                  data.loginMode = "sm"
                  data.clientSource = "2",
                      this.$post("/gateway/wechatQRCodeLogin", code)
                      .then(({
                          data
                      }) => {
                          if (data && data.code === "C0000") {
                              this.bindForm.openId = data.result.openId
                              this.$message({
                                    type: 'success',
                                    message: '扫码成功！',
                                    offset: 380,
                                    grouping: true
                              })
                              if (data.result.isBindWechat) {
                                  this.authAfter(data)
                              } else {
                                  this.bindDialog = true
                              }
                          } else {
                              this.wechatLoginInit()
                          }
                      })
                      .catch(() => {
                          this.wechatLoginInit()
                      });
              },
              bindFormSubmit() {
                  this.$refs.bindForm.validate(valid => {
                      if (valid) {
                          this.bindLoading = true
                          this.$post(
                                "/gateway/auth", 
                                    {
                                      username: this.bindForm.userName,
                                      password: this.bindForm.password,
                                      loginType: "pc",
                                      loginMode: "sm",
                                      clientSource: "2",
                                      cnAddress: this.cnAddress,
                                      loginRemoteIp: this.loginRemoteIp,
                                      openId: this.bindForm.openId
                                  }
                              )
                              .then(({
                                  data
                              }) => {
                                  if (data && data.code === "C0000") {
                                      if (data.result.isPwdExpired) {
                                          this.password.show = true
                                      } else {
                                          this.authAfter(data)
                                      }
                                  } else {
                                  }
                              })
                              .catch(() => {
                                  setTimeout(() => {
                                      this.bindLoading = false
                                  }, 1000)
                              })
                              .finally(() => {
                                  setTimeout(() => {
                                      this.bindLoading = false
                                  }, 1000)
                              });
                      }
                  });
              },
              bindDialogClose() {
                  this.bindDialog = false
                  this.wechatLoginInit()
              },
              getAccount() {
                  var curTime = new Date().getTime()
                  var data = localStorage.getItem("information")
                  var dataObj = JSON.parse(data)
                  if (data) {
                      if (curTime - dataObj.time > 1000 * 60 * 60 * 24 * 7) {
                          localStorage.removeItem("information")
                      } else {
                          this.dataForm.userName = dataObj.data.userName
                          this.dataForm.password = dataObj.data.password
                          this.checked = true
                      }
                  }
              },
              setAccount() {
                  if (this.checked) {
                      var curTime = new Date().getTime()
                      localStorage.setItem(
                          "information",
                          JSON.stringify({
                              data: this.dataForm,
                              time: curTime
                          })
                      );
                  }
              },
              setTenant(isOuter) {
                  // userId
                  let userId = this.tenants[this.tenantId].id
                  this.ActionsUserId(userId);
                  // tenantId
                  this.ActionsTenantId(this.tenants[this.tenantId].tenantId)
                  this.setTenantState = true
                  this.$post("/p/tenant/checkTenant",{
                          id: this.tenants[this.tenantId].tenantId
                      }
                    ).then(res => {
                      this.setTenantState = false
                      // 初始化sessionStorage数据
                      this.$initSessionStorageData.init();
                      this.$router.replace({
                          path: "/",
                          query: {
                              isOuter: isOuter ? isOuter : ""
                          }
                      });
                  });
              },
              dataFormSubmit() {
                  this.$refs.dataForm.validate(valid => {
                      if (valid) {
                          this.fullscreenLoading = true
                          this.$post("/gateway/auth",{
                                      username: this.dataForm.userName,
                                      password: this.dataForm.password,
                                      loginType: "pc",
                                      loginMode: "mm",
                                      clientSource: "2",
                                      cnAddress: this.cnAddress,
                                      loginRemoteIp: this.loginRemoteIp
                                  }
                              )
                              .then(({
                                  data
                              }) => {
                                  if (data && data.code === "C0000") {
                                      if (data.result.isPwdExpired) {
                                          this.password.show = true
                                      } else {
                                          this.authAfter(data)
                                      }
                                  }
                                  this.fullscreenLoading = false
                              })
                              .catch(() => {
                                  this.fullscreenLoading = false
                              });
                      }
                  });
              },
              authAfter(data) {
                  this.setAccount()
                  vueCookie.set('token', data.result.token, {
                        domain: process.env.VUE_APP_DOADMIN
                    });
                  // Cookies.set("token", data.result.token, { domain: ['localhost', '127.0.0.1'].includes(document.domain) ? document.domain: window.SITE_CONFIG.clientMainDomain})
                  // this.ActionsUpdateId(data.result.loginAuthDto.accountId)
                  // this.ActionsUpdateName(data.result.userName)
                  // this.$cookie.set('userType', data.result.userType)
                  // this.ActionsUpdateId(data.result.userId)
                  // this.ActionsUpdateName(data.result.userName)
                  // // this.$cookie.set('id', data.result.userId)
                  // // alert(this.$store.state.user.id)
                  // this.$message({
                  //   message: '登录成功',
                  //   type: 'success'
                  // })
                  // this.$router.replace({ path: '/home' })
                  let accountId = data.result.loginAuthDto.accountId
                  // this.ActionsUserId(accountId)
                  this.ActionsLoginId(accountId)
                  console.log("测试登录1")
  
                  // 初始化sessionStorage数据
                  this.$initSessionStorageData.init()
  
                  if (data.result.loginAuthDto.isAdmin) {
                      console.log("测试登录2");
                      this.$get("/p/user/getUsersByAccountId", {
                              id: accountId
                          }
                        ).then(res => {
                          let userId = res.data.result[0].id
                          this.ActionsUserId(userId)
                          // 初始化sessionStorage数据
                          this.$initSessionStorageData.init()
                          this.$router.replace({
                              path: "/",
                              query: {
                                  isOuter: res.data.result[0].isOuter ?
                                      res.data.result[0].isOuter :
                                      ""
                              }
                          });
                      });
  
                      // // 初始化sessionStorage数据
                      // this.$initSessionStorageData.init()
  
                      // return this.$router.replace({ path: '/home' })
                  } else {
                      this.$post("/p/user/getUsersByAccountId",{
                              id: accountId
                          }
                      ).then(res => {
                          if (res.data && res.data.code === "C0000") {
                              if (!res.data.result.length) {
                                this.$message({
                                    type: 'error',
                                    message: '当前用户没有租户信息',
                                    offset: 380,
                                    grouping: true
                                })
                              } else if (res.data.result.length === 1) {
                                  this.tenantId = 0
                                  this.tenants = res.data.result
                                  this.setTenant(res.data.result[0].isOuter)
                              } else {
                                  this.dialog = true
                                  this.tenants = res.data.result
                              }
                          }
                      })
                  }
              },
              closePassword() {
                  this.$refs.passwordForm.resetFields()
                  this.password.show = false
                  this.$post('/p/user/logout').then(({ data }) => {
                    this.$router.go(0)
                })
              },
              handlerGohome() {
                  window.location.href = "https://www.z-easy.com.cn/"
              },
              resetPassword() {
                  this.$refs.passwordForm.validate(valid => {
                      if (valid) {
                          this.loading = true;
                          let data = {
                              username: this.dataForm.userName,
                              password: this.dataForm.password,
                              newPassword: this.password.data.pass,
                              confirmPassword: this.password.data.checkPass
                          };
                          this.$post('/p/loginAccount/updatePwdByAccount', data).then(({ data }) => {
                            if (data && data.code === 'C0000') {
                            this.$message({
                                type: 'success',
                                message: data.message,
                                offset: 380,
                                grouping: true
                            })
                            setTimeout(() => {
                                this.closePassword()
                            }, 1000)
                            }
                        })
                      }
                  });
              },
              handleClick () {
                  window.open('https://www.z-easy.com.cn/')
              },
              handleRegister () {
                  const currentScroll = document.documentElement.scrollTop || document.body.scrollTop; // 已经被卷掉的高度
                  const clientHeight = document.documentElement.clientHeight; // 浏览器高度
                  const scrollHeight = document.documentElement.scrollHeight; // 总高度
                  if (scrollHeight - 10 > currentScroll + clientHeight) {
                      window.requestAnimationFrame(smoothscroll);
                      window.scrollTo(0, currentScroll + (scrollHeight - currentScroll - clientHeight) / 2);
                  }
              },
              handlerConsult () {
                  this.dialogVisible = true
              },
              ...mapActions([
                  "ActionsLoginId",
                  "ActionsUserId",
                  "ActionsTenantId",
                  "ActionsUpdateName"
              ])
          }
      };
  </script>
<style lang="scss" >
body {
    overflow: auto;
}
</style>

  <style lang="scss" scoped>
  .register {
  overflow-x: hidden;
  .clearfix:before,
  .clearfix:after {
    content: "";
    display: block;
    clear: both;
    height: 0;
    line-height: 0;
  }
  .clearfix {
    zoom: 1;
  }
  html,
  body {
    height: 100%;
    width: 100%;
  }
  .codeLogin {
        width: 480px;
        padding: 40px;
    }
  .register {
      overflow-x: hidden;
      width: 100%;
  ::-webkit-input-placeholder {
      color: #606266 !important;
      font-weight: 400;
  }
  ::-webkit-input-placeholder { /* WebKit, Blink, Edge */
      color: #606266;
      font-weight: 400;
  }
  :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
      color: #606266;
      font-weight: 400;
  }
  ::-moz-placeholder { /* Mozilla Firefox 19+ */
      color: #606266;
      font-weight: 400;
  }
  :-ms-input-placeholder { /* Internet Explorer 10-11 */
      color: #606266;
      font-weight: 400;
  }
    .register-qrcode {
      width: 202px;
      height: 245px;
      overflow: hidden;
      margin: 0 auto;
      margin-top: 40px;
      margin-bottom: 15px;
      iframe {
        width: 202px;
        .wrp_code {
          .lightBorder {
            width: 100px;
          }
        }
      }
      img {
        height: 100px;
      }
    }
   
  //   display: table;
    width: 100%;
    height: 100%;
    .registration {
      width: 300px;
      margin-left: 50px;
      height: 40px;
      font-size: 18px;
      line-height: 40px;
    }
    .forgot-password:hover {
      color: #606266;
    }
    .forgot-password {
      width: 120px;
      cursor: pointer;
      height: 42px;
      color: #9e9e9e;
      float: right;
      border-bottom: 1px solid #bebec4;
      border-top: 1px solid #bebec4;
      border-right: 1px solid #bebec4;
      .button {
        width: 100%;
        height: 100%;
        float: right;
        position: relative;
      }
    }
    .impowerBox {
        top: 45px;
        left: 50px;
    }
}
    .register-logo {
      position: absolute;
      top: 40px;
      left: 40px;
    }
    .register-top{
        position: relative;
        img{
            width: 100%;
            height: 100%;
        }
        width: 100vw !important;
        .lg-rg {
          position: relative;
        }
        .lg-tb {
          position: absolute;
          bottom: 5%;
          left: calc(50% - 110px);
          img {
             
              height: 100%;
              width: 100%;
              cursor: pointer;
          }
        }
        .lg-tb-search {
            // cursor: pointer;
            // position: absolute;
            // position: absolute;
            // right: 40px;
            // bottom: 20px;
            animation: breathe 1.1s infinite;
            // img {
            //     width: 223px;
            //     height: 62px;
            // }
        }
        @keyframes breathe{
            0%{ transform: scale(.9);}
            50%{ transform: scale(1.05);}
            100%{ transform: scale(.9);}
        }
        .lg-rg-2 {
          font-size:0;
          position: relative;
          .lg-more {
              position: absolute;
              bottom: 31%;
              left: calc(50% - 110px);
         
              cursor: pointer;
              img {
                  width: 100%;
                  height: 100%;
              }
          }
        }
    }
    .register-bg {
    background-image: url("@/assets/img/client/login/2022-10-27-4.jpg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
        width: 100vw !important;
        height: 100vh;
        position: relative;
      vertical-align: middle;
      display: table-cell;
      text-align: center;
      // _position: absolute;
      _top: 50%;
      _left: 50%;
    }
    .el-form-item {
      margin: 0 0 20px 0;
    }
    .el-input__inner {
      height: 42px;
      line-height: 42px;
      font-size: inherit;
    }
    .el-form-item__content {
      line-height: 42px;
      height: 42px;
      font-size: 14px;
    }
    .register-follow {
      position: absolute;
      right: 40px;
      bottom: 40px;
      height: 124px;
      .img {
        width: 100px;
        height: 100px;
      }
      .text {
        width: 100%;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        text-align: center;
        color: #fff;
        background: rgba(255, 255, 255, 0.256);
      }
    }
    .register-foot-img {
      cursor: pointer;
      right: 30px;
      bottom: 60px;
      position: fixed;
      z-index: 2000000000;
      img {
        width: 145px;
        height: 53px;
      }
    }
    .bindForm {
      .el-form-item__label {
        margin-bottom: 0;
        line-height: 42px;
      }
    }
  }
  .register-content {
        // .title{
        //   background: url("@/assets/img/client/login/slogan.png") no-repeat center;
        //   width: 369px;
        //   height: 113px;
        //   background-size: cover;
        // }
    width: 370px;
    height: 500px;
    margin: auto;
    margin-left: 60vw;
    _position: relative;
    _top: -50%;
    _left: -50%;
    .site-name {
      width: 373px;
      height: 32px;
      margin: 0 auto 30px;
      font: 400 30px/30px "SimSun";
      color: #d0edff;
      background: url("@/assets/img/client/login/name.png") no-repeat center;
      background-size: cover;
    }
    .form-content {
      position: relative;
      width: 100%;
      height: 350px;
      // margin-top: -150px;
      overflow: hidden;
      background: #fff;
      box-shadow: 0 3px 30px 0 #5484a2;
      border-radius: 8px;
      .form-box {
        width: 100%;
        height: 100%;
        float: right;
        input {
          background-color: unset;
        }
        .el-col {
          margin-top: 30px;
          font-weight: 500;
          font-size: 18px;
          line-height: 18px;
          cursor: pointer;
        }
        .active {
          color: #0068b7;
          // border-bottom: solid 2px;
          // padding-bottom: 10px;
          // width: 60%;
          // text-align: center;
          // border: 80%;
          // margin: auto;
        }
        .active-bar {
          position: absolute;
          bottom: 0px;
          left: 0px;
          height: 2px;
          background-color: #0068b7;
          z-index: 1;
          transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1) 0s;
          list-style: none;
        }
        .inner {
          color: #333;
        }
        .el-row {
          // border-bottom: solid 2px #e4e7ed;
          padding-bottom: 10px;
        }
        .user-client-register {
          margin-top: 30px;
        }
        .user-client-reg {
          margin-top: 30px;
          .el-icon-message,
          .el-icon-mobile-phone {
            color: #606266;
            width: 32px;
            height: 42px;
            font-weight: 600;
            font-size: 17px;
          }
          .phone-code {
            div {
              float: left;
            }
            .ph-code-number {
              width: 180px;
              padding-right: 5px
            }
            .ph-code-btn {
              button {
                color:  #000;
                background-color: unset;
                height: 42px;
                font-size: 14px;
                // border: 1px solid #bebec4;
                border-left: none;
                width: 120px;
                border: none;
                background-color: #F0F2F5;
              }
            }
          }
        }
        h1 {
          width: 300px;
          height: 40px;
          margin: 20px auto 10px;
          font-weight: 500;
          font-size: 40px;
          line-height: 40px;
        }
            .user-icon {
              color: #606266;
              display: inline-block;
              width: 32px;
              height: 42px;
              background: url("@/assets/img/client/login/user.svg") no-repeat
                center;
            }
        form {
          display: block;
          width: 300px;
          margin: auto;
          .user {
            input {
            //   padding-left: 40px;
              height: 42px;
              border-radius: 0;
            }
          }
          .pwd {
            margin-bottom: 6px;
            input {
            //   padding-left: 40px;
              height: 42px;
              border-radius: 0;
            }
            .pwd-icon {
              display: inline-block;
              width: 32px;
              height: 42px;
              background: url("@/assets/img/client/login/pwd.svg") no-repeat center;
            }
          }
          .checked {
            text-align: left;
            margin-bottom: 24px;
            .el-checkbox__inner {
              border-radius: 0;
            }
          }
        }
        .register-btn-submit {
          width: 100%;
          height: 42px;
          border-radius: 0;
          border: none;
          font-size: 14px;
          background: linear-gradient(
            180deg,
            rgba(0, 161, 220, 1) 0%,
            rgba(0, 104, 183, 1) 100%
          );
          &:hover,
          &:active {
            opacity: 0.9;
          }
        }
      }
    }
    .register-mode {
      position: absolute;
      top: 2px;
      right: 2px;
      width: 50px;
      height: 50px;
      cursor: pointer;
      .basic {
        width: 50px;
        height: 50px;
        background: url("@/assets/img/client/login/mode-basic.png") no-repeat right
          top;
      }
      .qrcode {
        width: 50px;
        height: 50px;
        background: url("@/assets/img/client/login/mode-qrcode.png") no-repeat
          center;
      }
    }
  }
  .resetPassword {
    .el-dialog__body {
      min-height: 0;
    }
    .el-form-item__label {
      margin-bottom: 0;
      line-height: 42px;
    }
  }
  
  .qidian_wpa_img {
    display: none;
  }
  .register-dialog {
  
  }

  // 微信登录二维码页面css，base64编码后放入ba64Css中
  // .impowerBox {width: 200px;}
  // .impowerBox .qrcode {width: 200px;margin: 0;}
  // .impowerBox .title {display: none;}
  // .impowerBox .info {width: 200px;}
  // .impowerBox .status {padding: 0;text-align: center;}
  // .impowerBox .status .status_icon {display: none;}
  </style>
  